import makeStyles from '@mui/styles/makeStyles';
import {amber, blue, blueGrey, green, indigo} from "@mui/material/colors";
import bg from "../../assets/v2/Logo-Orca.svg"

const glassCard = (theme, strength = 0.72) => ({
    border: theme.palette.mode === "light" ? "1px solid rgba(28, 54, 78, 0.1)" : "1px solid rgba(255, 255, 255, 0.1)",
    background: theme.palette.mode === "light"
        ? `linear-gradient(180deg, rgba(255, 255, 255, ${Math.min(strength + 0.16, 0.92)}) 0%, rgba(255, 255, 255, ${strength}) 100%)`
        : "linear-gradient(180deg, rgba(34, 42, 54, 0.9) 0%, rgba(24, 31, 43, 0.72) 100%)",
    boxShadow: theme.palette.mode === "light" ? "0 10px 30px rgba(28, 54, 78, 0.08)" : "0 12px 34px rgba(0, 0, 0, 0.32)",
    backdropFilter: "blur(8px) saturate(130%)",
    WebkitBackdropFilter: "blur(8px) saturate(130%)",
});


export const BaseStyle = makeStyles(theme => ({
    main: {
        //backgroundColor: theme.palette.mode === "light" ? "#c3e3ff" : theme.palette.background.default,
        backgroundColor: theme.palette.mode === "light" ? "rgba(235, 243, 250, 0.92)" : theme.palette.background.default,
        backgroundImage: theme.palette.mode === "light"
            ? "radial-gradient(circle at top center, rgba(79, 195, 247, 0.12), transparent 30%), radial-gradient(circle at 10% 18%, rgba(48, 79, 254, 0.055), transparent 0 280px), linear-gradient(180deg, #f4f9fd 0%, #ebf3fa 100%)"
            : "radial-gradient(circle at top center, rgba(79, 195, 247, 0.08), transparent 30%), linear-gradient(180deg, #151821 0%, #0c0e13 100%)",
        //backgroundColor: theme.palette.mode === "light" ? "rgba(255, 255, 255, 0.4)" : "rgba(0,0,0,0.4)",
        minHeight: "100vh",
        width: "100%",
        position: "absolute",
        paddingBottom: 20,
        scrollbarWidth: "none", // Nasconde la scrollbar in Firefox
        "&::-webkit-scrollbar": {
            display: "none", // Nasconde la scrollbar in WebKit
        },
    },
    mainBg: {
        //backgroundColor: theme.palette.mode === "light" ? "#c3e3ff" : theme.palette.background.default,
        //backgroundColor: theme.palette.background.default,
        backgroundColor: theme.palette.mode === "light" ? "rgba(84,162,253,0.55)" : "rgba(0,0,0,0.5)",
        minHeight: "100vh",
        width: "100%",
        position: "absolute",
        paddingBottom: 20,
        scrollbarWidth: "none", // Nasconde la scrollbar in Firefox
        "&::-webkit-scrollbar": {
            display: "none", // Nasconde la scrollbar in WebKit
        },
    },
    mainNoBgCol: {
        //backgroundColor: theme.palette.background.default,
        minHeight: "100vh",
        width: "100%"
    },
    // Classe per nascondere la scrollbar
    hideScrollbar: {
        /* Per Chrome, Safari e le versioni più moderne di Edge */
        '&::-webkit-scrollbar': {
            display: 'none',
        },
        /* Per Firefox */
        scrollbarWidth: 'none',
    },
    transparent10: {
        ...glassCard(theme, 0.34),
    },
    transparent20: {
        ...glassCard(theme, 0.44),
    },
    transparent30: {
        ...glassCard(theme, 0.52),
    },
    hover30: {
        "&:hover": {
            backgroundColor: theme.palette.mode === "light" ? "rgba(79, 195, 247, 0.08)" : "rgba(79, 195, 247, 0.08)",
            border: theme.palette.mode === "light" ? "1px solid rgba(48, 79, 254, 0.25)" : "1px solid rgba(79, 195, 247,0.22)",
        }
    },
    transparent50: {
        ...glassCard(theme, 0.62),
    },
    transparent: {
        ...glassCard(theme, 0.72),
    },
    transparent80: {
        ...glassCard(theme, 0.82),
    },
    transparent90: {
        ...glassCard(theme, 0.9),
    },
    indigo200Background: {
        backgroundColor: indigo["A200"]
    },
    indigo300Background: {
        backgroundColor: indigo[300]
    },
    blue300Background: {
        backgroundColor: blue[300]
    },
    blurred20: {
        backdropFilter: "blur(8px) saturate(130%)",
        WebkitBackdropFilter: "blur(8px) saturate(130%)",
    },
    backdrop: {
        zIndex: theme.zIndex.drawer + 5000,
        color: '#fff',
    },
    input: {
        textTransform: "uppercase",
    },
    borderInput: {
        '& .MuiOutlinedInput-root': {
            borderRadius: 24,
        },
    },
    capitalizeInput: {
        textTransform: "capitalize",
    },
    zIndex9000: {
        zIndex: 9000,
    },
    roundBorder: {
        borderRadius: 24,
        border: theme.palette.mode === "light" ? "1px solid rgba(28, 54, 78, 0.1)" : "1px solid rgba(255, 255, 255, 0.1)",
    },
    dialogPaper: {
        borderRadius: "24px !important",
        border: "1px solid var(--atl-border, rgba(28, 54, 78, 0.12)) !important",
        background: "var(--atl-surface-solid-strong, #ffffff) !important",
        backgroundColor: "var(--atl-surface-solid-strong, #ffffff) !important",
        backgroundImage: "none !important",
        backgroundClip: "padding-box !important",
        color: "var(--atl-text, inherit) !important",
        boxShadow: theme.palette.mode === "light"
            ? "0 24px 70px rgba(28, 54, 78, 0.18) !important"
            : "0 28px 82px rgba(0, 0, 0, 0.5) !important",
        backdropFilter: "none !important",
        WebkitBackdropFilter: "none !important",
        display: "flex !important",
        flexDirection: "column",
        position: "relative",
        maxHeight: "min(860px, calc(100vh - 48px)) !important",
        overflow: "hidden",
        "&.MuiDialog-paperWidthXs": {
            maxWidth: "500px !important",
        },
        "&.MuiDialog-paperWidthSm": {
            maxWidth: "660px !important",
        },
        "&.MuiDialog-paperWidthMd": {
            maxWidth: "980px !important",
        },
        "&.MuiDialog-paperWidthLg": {
            maxWidth: "1240px !important",
        },
        "&.MuiDialog-paperFullScreen": {
            maxWidth: "100% !important",
            maxHeight: "100% !important",
            height: "100% !important",
        },
        [theme.breakpoints.down("sm")]: {
            width: "calc(100% - 24px) !important",
            maxWidth: "calc(100% - 24px) !important",
            maxHeight: "calc(100% - 24px) !important",
            margin: "12px !important",
            borderRadius: "20px !important",
        },
        "& .MuiDialogTitle-root": {
            paddingBottom: theme.spacing(0.75),
            flex: "0 0 auto",
        },
        "& .MuiDialogContent-root": {
            paddingTop: theme.spacing(1),
            flex: "1 1 auto",
            minHeight: 0,
        },
        "& .MuiDialogActions-root": {
            borderTop: "0 !important",
            background: "var(--atl-surface-solid-strong, #ffffff) !important",
            backgroundColor: "var(--atl-surface-solid-strong, #ffffff) !important",
            backgroundImage: "none !important",
            boxShadow: "none !important",
            paddingTop: theme.spacing(1),
            flex: "0 0 auto",
        },
        "& .MuiDialogActions-root .MuiButton-root": {
            "--dialog-action-color": "var(--atl-blue, #304ffe)",
            minHeight: 36,
            borderRadius: "12px !important",
            border: "1px solid color-mix(in srgb, var(--dialog-action-color) 34%, var(--atl-border, rgba(28, 54, 78, 0.12))) !important",
            background: "color-mix(in srgb, var(--dialog-action-color) 10%, var(--atl-surface-solid, #f7fbff)) !important",
            color: "var(--atl-text, inherit) !important",
            boxShadow: "none !important",
            textTransform: "none !important",
            fontWeight: "850 !important",
            lineHeight: "1.1 !important",
            padding: `${theme.spacing(0.75, 1.35)} !important`,
            transition: "background-color 0.18s ease, border-color 0.18s ease, box-shadow 0.18s ease, transform 0.18s ease !important",
            "& .MuiSvgIcon-root": {
                color: "var(--dialog-action-color) !important",
                fontSize: "20px !important",
            },
            "&:hover": {
                borderColor: "color-mix(in srgb, var(--dialog-action-color) 48%, var(--atl-border, rgba(28, 54, 78, 0.12))) !important",
                background: "color-mix(in srgb, var(--dialog-action-color) 15%, var(--atl-surface-solid, #f7fbff)) !important",
                boxShadow: "0 10px 20px color-mix(in srgb, var(--dialog-action-color) 12%, transparent) !important",
            },
        },
        "& .MuiDialogActions-root .MuiButton-containedSuccess, & .MuiDialogActions-root .MuiButton-colorSuccess": {
            "--dialog-action-color": "var(--atl-green, #34a853)",
        },
        "& .MuiDialogActions-root .MuiButton-containedError, & .MuiDialogActions-root .MuiButton-colorError": {
            "--dialog-action-color": "var(--atl-red, #ea4335)",
        },
        "& .MuiDialogActions-root .MuiButton-containedWarning, & .MuiDialogActions-root .MuiButton-colorWarning": {
            "--dialog-action-color": "var(--atl-yellow, #fbbc05)",
        },
    },
    dialogPaperWithTitle: {
        "& .MuiDialogContent-root": {
            paddingTop: `${theme.spacing(9)} !important`,
        },
    },
    dialogTitle: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: theme.spacing(1.5),
        position: "absolute",
        top: 0,
        left: 0,
        right: 0,
        borderBottom: "0 !important",
        background: "color-mix(in srgb, var(--atl-surface-solid-strong, #ffffff) 72%, transparent) !important",
        backgroundColor: "color-mix(in srgb, var(--atl-surface-solid-strong, #ffffff) 72%, transparent) !important",
        backgroundImage: "none !important",
        color: "var(--atl-text, inherit) !important",
        backdropFilter: "blur(14px) saturate(150%) !important",
        WebkitBackdropFilter: "blur(14px) saturate(150%) !important",
        zIndex: 2,
    },
    dialogTitleCopy: {
        minWidth: 0,
        display: "grid",
        gap: 3,
    },
    dialogTitleText: {
        minWidth: 0,
        overflow: "hidden",
        textOverflow: "ellipsis",
        lineHeight: 1.15,
    },
    dialogSubtitle: {
        minWidth: 0,
        color: "var(--atl-text-soft, inherit)",
        fontSize: "13px",
        fontWeight: 700,
        lineHeight: 1.25,
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
    },
    dialogCloseButton: {
        width: "36px !important",
        height: "36px !important",
        flex: "0 0 auto",
        border: "1px solid var(--atl-border, rgba(28, 54, 78, 0.12)) !important",
        borderRadius: "12px !important",
        background: "color-mix(in srgb, var(--atl-blue, #304ffe) 8%, var(--atl-surface-solid, #f7fbff)) !important",
        color: "var(--atl-text-soft, inherit) !important",
        boxShadow: "none !important",
        "& .MuiSvgIcon-root": {
            color: "var(--atl-blue, #304ffe) !important",
        },
        "&:hover": {
            borderColor: "color-mix(in srgb, var(--atl-blue, #304ffe) 42%, var(--atl-border, rgba(28, 54, 78, 0.12))) !important",
            background: "color-mix(in srgb, var(--atl-blue, #304ffe) 14%, var(--atl-surface-solid, #f7fbff)) !important",
        },
    },
    dialogContent: {
        overflowY: "auto !important",
        scrollbarWidth: "thin",
        background: "var(--atl-surface-solid-strong, #ffffff) !important",
        backgroundColor: "var(--atl-surface-solid-strong, #ffffff) !important",
        backgroundImage: "none !important",
        color: "var(--atl-text, inherit) !important",
        "&::-webkit-scrollbar": {
            width: 7,
        },
        "&::-webkit-scrollbar-track": {
            background: "transparent",
        },
        "&::-webkit-scrollbar-thumb": {
            borderRadius: 999,
            background: "color-mix(in srgb, var(--atl-text-muted, #8292a1) 40%, transparent)",
        },
    },
    dialogContentWithTitle: {
        paddingTop: `${theme.spacing(9)} !important`,
    },
    dialogContentWithSubtitle: {
        paddingTop: `${theme.spacing(11)} !important`,
    },
    darkBlueBackground: {
        backgroundColor: theme.palette.text.primary
    },
    shadow24: {
        boxShadow: theme.palette.mode === "light" ? "0 10px 30px rgba(28, 54, 78, 0.08)" : "0 12px 34px rgba(0, 0, 0, 0.32)",
        zIndex: 1000,
    },
    hoverShadow: {
        transition: "transform 0.18s ease, box-shadow 0.18s ease",
        "&:hover": {
            transform: "translateY(-1px)",
            boxShadow: theme.palette.mode === "light" ? "0 14px 34px rgba(28, 54, 78, 0.12)" : "0 14px 38px rgba(0, 0, 0, 0.38)",
        }
    },
    hoverShadowColor: {
        transition: "transform 0.18s ease, box-shadow 0.18s ease, background-color 0.18s ease",
        "&:hover": {
            transform: "translateY(-1px)",
            boxShadow: theme.palette.mode === "light" ? "0 14px 34px rgba(28, 54, 78, 0.12)" : "0 14px 38px rgba(0, 0, 0, 0.38)",
            backgroundColor: theme.palette.mode === "light" ? "rgba(79, 195, 247, 0.08)" : blueGrey[900],
        }
    },
    roundBorderTop: {
        borderRadius: "24px 24px 0 0",
    },
    roundBorderBottom: {
        borderRadius: "0px 0px 24px 24px",
    },
    noRoundBorder: {
        borderRadius: 0,
    },
    lightAmberBackground: {
        backgroundColor: theme.palette.mode === "light" ? amber[100] : amber[700]
    },
    roundPaper: {
        borderRadius: 24,
        height: "100%",
        ...glassCard(theme),
    },
    padding1: {
        padding: theme.spacing(1)
    },
    padding2: {
        padding: theme.spacing(2)
    },
    flexRight: {
        display: "flex",
        justifyContent: "flex-end"
    },
    badgeRoot: {
        display: 'flex',
        '& > *': {
            margin: theme.spacing(1),
        },
    },
    buttonGroup: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        '& > *': {
            margin: theme.spacing(1),
        },
    },
    flexStart: {
        display: "flex",
        justifyContent: "flex-start",
        flexWrap: "wrap"
    },
    flexCenter: {
        display: "flex",
        justifyContent: "center",
        flexWrap: "wrap"
    },
    roundButton: {
        borderRadius: 24,
    },
    noBg: {
        backgroundColor: theme.palette.mode === "light" ? "rgba(255, 255, 255,0.52)" : "rgba(24,31,43,0.58)",
        backdropFilter: "blur(8px) saturate(130%)",
        WebkitBackdropFilter: "blur(8px) saturate(130%)",
    },
    roundCard: {
        borderRadius: 24,
        ...glassCard(theme),
        /*width: 180,*/
        width: 280,
        /*height: 180,*/
        margin: theme.spacing(1),
        textAlign: "center",
        transition: "transform 0.18s ease, box-shadow 0.18s ease",
        '&:hover': {
            transform: "translateY(-2px)",
            boxShadow: theme.palette.mode === "light" ? "0 16px 36px rgba(28, 54, 78, 0.13)" : "0 16px 40px rgba(0,0,0,0.38)",
        },
    },
    roundCardFile: {
        borderRadius: 22,
        ...glassCard(theme),
        width: 240,
        margin: theme.spacing(1),
        textAlign: "center",
    },
    classCard: {
        borderRadius: 24,
        width: 200,
        height: 100,
        margin: theme.spacing(1),
    },
    classActionCard: {
        borderRadius: 24,
        ...glassCard(theme),
        width: 280,
        height: 176,
        margin: theme.spacing(1),
        transition: "transform 0.18s ease, box-shadow 0.18s ease, border-color 0.18s ease",
        "&:hover": {
            transform: "translateY(-2px)",
            borderColor: theme.palette.mode === "light" ? "rgba(48, 79, 254, 0.18)" : "rgba(79, 195, 247, 0.22)",
        }
    },
    classActionCardNoHeight: {
        borderRadius: 24,
        ...glassCard(theme),
        width: 280,
        margin: theme.spacing(1),
        transition: "transform 0.18s ease, box-shadow 0.18s ease, border-color 0.18s ease",
        "&:hover": {
            transform: "translateY(-2px)",
            borderColor: theme.palette.mode === "light" ? "rgba(48, 79, 254, 0.18)" : "rgba(79, 195, 247, 0.22)",
        }
    },
    classActionCardNoHover: {
        borderRadius: 24,
        ...glassCard(theme),
        width: 280,
        height: 176,
        margin: theme.spacing(1),
    },
    cardMedia: {
        height: 50,
        width: 50,
        margin: "auto",
        marginTop: theme.spacing(1)
    },
    roundCardFullWidth: {
        borderRadius: 24,
        ...glassCard(theme),
        width: "100%",
        height: 160,
        margin: theme.spacing(1, 1, 1, 0),
        textAlign: "center",
        transition: "transform 0.18s ease, box-shadow 0.18s ease, background-color 0.18s ease, color 0.18s ease",
        '&:hover': {
            transform: "translateY(-2px)",
            boxShadow: theme.palette.mode === "light" ? "0 16px 36px rgba(28, 54, 78, 0.13)" : "0 16px 40px rgba(0,0,0,0.38)",
            backgroundColor: theme.palette.primary.main,
            color: "#FFF"
        },
    },
    roundAccordion: {
        borderRadius: 24,
        ...glassCard(theme),
        marginTop: 10,
        position: "inherit",
        width: "100%"
    },
    heading: {
        fontSize: theme.typography.pxToRem(15),
    },
    secondaryHeading: {
        fontSize: theme.typography.pxToRem(15),
        color: theme.palette.text.secondary,
    },
    faqDetails: {
        "& blockquote": {
            color: "#424242",
            fontStyle: "italic",
            borderLeft: "4px solid #d5d5d5",
            display: "block",
            padding: 10,
        },
        "& code": {
            backgroundColor: "#eeeeee",
            padding: theme.spacing(1, 2, 1, 2),
            width: "100%"
        },
        "& pre": {
            margin: 0,
            backgroundColor: "#eeeeee",
            padding: theme.spacing(1, 2, 1, 2),
        },
        "& a": {
            color: theme.palette.primary.main
        }
    },
    blue: {
        backgroundColor: indigo["A700"],
        color: theme.palette.getContrastText(indigo["A700"]),
    },
    flexHeight: {
        height: 245,
        [theme.breakpoints.up(1920)]: {
            height: 245,
        },
        [theme.breakpoints.down(1920)]: {
            height: 416,
        },
    },
    margin1: {
        margin: theme.spacing(1),
    },
    margin2: {
        margin: theme.spacing(2),
    },
    large: {
        width: theme.spacing(7),
        height: theme.spacing(7),
    },
    ultraLarge: {
        width: theme.spacing(25),
        height: theme.spacing(25),

    },
    showOnHover: {
        "&:hover": {
            "& $visibleOnHover": {
                display: "block"
            }
        }
    },
    visibleOnHover: {
        display: "none",
        cursor: "pointer",
        fontSize: 40,
        position: "absolute",
        margin: 12,
        top: 0,
        left: 0,
        width: 200,
        height: 200,
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        borderRadius: "50%",
        color: "#FFF",
        padding: 50
    },
    inline: {
        display: 'inline',
    },
    itemTicket: {
        width: "100%",
        marginBottom: 3,
        borderRadius: 24,
        transition: "transform .2s",
        "&:hover": {
            /*"& $last": {
             display: "block",
             },
             "& $details": {
             display: "none",
             },*/
        }
    },
    timeline: {
        width: "100%",
        height: "100%"
    },
    fabContainer: {
        position: "fixed",
        maxHeight: "100vh",
        width: "100%",
        display: "flex",
        flexDirection: "row",
        bottom: 0,
        zIndex: 1200,
        justifyContent: "flex-end",
        pointerEvents: "none",
        //paddingRight: 50
    },
    fab: {
        margin: theme.spacing(1),
        pointerEvents: "auto",
        boxShadow: theme.shadows[24],
        transition: ".2s",
        "&:hover": {
            boxShadow: theme.shadows[4],
            transform: "scale(0.95)",
        }
    },
    amberFab: {
        backgroundColor: amber[500],
        color: "#000",
        "&:hover": {
            backgroundColor: amber[700],
        }
    },
    greenFab: {
        backgroundColor: green[500],
        color: "#FFF",
        "&:hover": {
            backgroundColor: green[700],
        }
    },
    extendedIconFab: {
        marginRight: theme.spacing(1),
    },
    drawer: {
        width: 280,
        flexShrink: 0,
        whiteSpace: 'nowrap',
        ...glassCard(theme, 0.84),
    },
    drawerBig: {
        width: 300,
        flexShrink: 0,
        whiteSpace: 'nowrap',
        ...glassCard(theme, 0.84),
    },
    openDrawer: {
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    closedDrawer: {
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        overflow: 'hidden',
        width: 70,
    },
    filterSearchPaper: {
        height: "100%",
        //height: 330,
        flexShrink: 0,
        whiteSpace: 'nowrap',
        /*[theme.breakpoints.down("sm")]: {
         height: 500,
         },*/
    },
    openFilterPaper: {
        transition: theme.transitions.create('height', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    closedFilterPaper: {
        transition: theme.transitions.create('height', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        overflow: 'hidden',
        height: 60.06
    },
    contentParent: {
        height: "100%",
        width: "100%",
        overflow: "hidden",
    },
    content: {
        flexGrow: 1,
        padding: theme.spacing(3),
        overflowY: "scroll",
        maxHeight: 858,
        scrollbarWidth: "none", // Nasconde la scrollbar in Firefox
        "&::-webkit-scrollbar": {
            display: "none", // Nasconde la scrollbar in WebKit
        },
    },
    content800: {
        flexGrow: 1,
        padding: theme.spacing(3),
        overflowY: "scroll",
        maxHeight: 800,
        scrollbarWidth: "none", // Nasconde la scrollbar in Firefox
        "&::-webkit-scrollbar": {
            display: "none", // Nasconde la scrollbar in WebKit
        },
    },
    content1000: {
        flexGrow: 1,
        padding: theme.spacing(3),
        overflowY: "scroll",
        maxHeight: 1200,
        scrollbarWidth: "none", // Nasconde la scrollbar in Firefox
        "&::-webkit-scrollbar": {
            display: "none", // Nasconde la scrollbar in WebKit
        },
    },
    small: {
        width: theme.spacing(3),
        height: theme.spacing(3),
    },
    mailCard: {
        marginBottom: theme.spacing(1),
        ...glassCard(theme),
    },
    chatBox: {
        backgroundColor: theme.palette.mode === "light" ? "snow" : "darkgrey"
    },

    chatCard: {
        zIndex: 10000,
        width: 520,
        height: 640,
        position: "fixed",
        bottom: 10,
        right: 10,
        borderRadius: 24,
        boxShadow: "0 10px 20px -12px",
        backgroundImage: theme.palette.mode === "light" ?
            `linear-gradient(rgba(255,250,250,.8), rgba(255,250,250,.8)), url(${bg})` :
            `linear-gradient(rgba(48,48,48,.8), rgba(48,48,48,.8)), url(${bg})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "100px 100px",
        backgroundPosition: "center",
    },

    chatItem: {
        backgroundColor: theme.palette.background.paper + "!important",
        marginTop: 5
    },

    calendar: {
        display: "block",
        position: "relative",
        width: "100%",
    },
    selectedDay: {
        backgroundColor: theme.palette.primary.main,
        color: "#FFF"
    },
    disabledDay: {
        backgroundColor: theme.palette.mode === "light" ? "rgba(192,192,192,0.46)" : theme.palette.background.default,
    },
    monitoraggioContainer: {
        paddingLeft: 100,
        paddingRight: 100,
        [theme.breakpoints.down('lg')]: {
            paddingLeft: 50,
            paddingRight: 50,
        },
        [theme.breakpoints.down('sm')]: {
            paddingLeft: 0,
            paddingRight: 0,
        },
    },

    expand: {
        transform: 'rotate(0deg)',
        marginLeft: 'auto',
        transition: theme.transitions.create('transform', {
            duration: theme.transitions.duration.shortest,
        }),
    },
    expandOpen: {
        transform: 'rotate(180deg)',
    },
    hoverCell: {
        "&:hover": {
            backgroundColor: "rgba(0,0,0,0.2)"
        }
    },

    utenteCard: {
        borderRadius: 24,
        ...glassCard(theme),
        width: 320,
        height: 90,
        margin: theme.spacing(1),
        transition: "transform 0.18s ease, box-shadow 0.18s ease",
        "&:hover": {
            transform: "translateY(-2px)",
        }
    },

    logo: {
        width: 48,
        height: 48,
        marginTop: 10
    },

    formControl: {
        margin: theme.spacing(1),
        minWidth: 120,
    },
    selectEmpty: {
        marginTop: theme.spacing(2),
    },
    oneForColumnFlexStart: {
        display: "flex",
        justifyContent: "center",
        alignItems: "flex-start",
        flexDirection: "column"
    },
    oneForColumnCentered: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column"
    },
    customDivider: {
        marginBottom: 20,
        marginTop: 20,
        width: "100%",
        alignItems: 'stretch',
    },
    bold: {
        fontWeight: 'bold',
    },
    menuItem2Line: {
        whiteSpace: 'normal',
        wordBreak: 'break-word',
        overflowWrap: 'break-word',
        display: 'block' // Assicura che il contenuto possa andare a capo

    },
    scrollContainer: {
        position: 'relative',
        height: '100vh',
        overflowY: 'auto',
        zIndex: '0',
        overflowX: 'hidden',
        WebkitOverflowScrolling: "touch", // scroll fluido su iOS
    }
}))
